export const GET_PLACES = 'GET_PLACES';
export const GET_PLACE = 'GET_PLACE';
